import { IMAGE_RATIO } from 'defs/assets';
import { ImageRatioValues } from 'defs/assets';
import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import { ImageDtoType } from 'types/services/magnolia/dtos/ImageDto';

export const loadAsset = (
	path: string,
	ratio: ImageRatioValues = IMAGE_RATIO.R1_1 as any
): Promise<AxiosResponse<ImageDtoType>> => {
	const requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/assets/${ratio}/${path}`;

	return axios.get(requestUrl, {
		withCredentials: false,
	});
};
